document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-farm-countdown]').forEach((section) => {
    const endValue = section.dataset.end;
    if (!endValue) return;

    const end = new Date(endValue).getTime();
    if (Number.isNaN(end)) return;

    const numbers = {
      days: section.querySelector('[data-days]'),
      hours: section.querySelector('[data-hours]'),
      minutes: section.querySelector('[data-minutes]'),
      seconds: section.querySelector('[data-seconds]'),
    };

    const tick = () => {
      const distance = end - Date.now();
      if (distance <= 0) {
        section.hidden = section.dataset.hideExpired === 'true';
        Object.values(numbers).forEach((node) => { if (node) node.textContent = '00'; });
        return false;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      if (numbers.days) numbers.days.textContent = String(days).padStart(2, '0');
      if (numbers.hours) numbers.hours.textContent = String(hours).padStart(2, '0');
      if (numbers.minutes) numbers.minutes.textContent = String(minutes).padStart(2, '0');
      if (numbers.seconds) numbers.seconds.textContent = String(seconds).padStart(2, '0');
      return true;
    };

    if (tick()) {
      const timer = window.setInterval(() => {
        if (!tick()) window.clearInterval(timer);
      }, 1000);
    }
  });
});
